import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image-plus-white--sprite",
  "use": "image-plus-white--sprite-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"image-plus-white--sprite\"><path fill=\"#fff\" class=\"cls-1\" d=\"M5,3A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2h9.09A5.55,5.55,0,0,1,14,20a5.93,5.93,0,0,1,.35-2H5l3.5-4.5,2.5,3L14.5,12l2.23,3A6,6,0,0,1,20,14a5.55,5.55,0,0,1,1,.09V5a2,2,0,0,0-2-2H5M19,16v3H16v2h3v3h2V21h3V19H21V16Z\" transform=\"translate(-3 -3)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol